<template>
  <div class="review-item pb-8 ">
    <div class="d-flex">
      <div class="avatar-wrapper pr-4">
        <AuthorAvatar :user="author" :size="48"></AuthorAvatar>
      </div>
 
      <div class="d-flex flex-column user-info-wrapper">
        <div class="d-flex justify-space-between user-info-review">
          <span>{{ author | authorFullName }}</span>
          <v-rating
            dense
            half-increments
            v-model="review.rating"
            background-color="gray"
            readonly
          ></v-rating>
        </div>

        <div class="caption">{{ review.created_at | fromNow("pt") }}</div>
      </div>
    </div>

    <h5> {{ review.title }}</h5>
    <div class="pb-1">
      <div>
        {{ review.comment }}
      </div>

      <div v-if="isAuthor">
        <v-btn
          class="mx-2"
          x-small
          icon
          color="primary"
          @click="removeReview()"
          :loading="deleting == review.id"
        >
          <v-icon dark> delete </v-icon>
        </v-btn>

        <v-btn class="mx-2" x-small icon color="primary" @click="editReview()">
          <v-icon dark> edit </v-icon>
        </v-btn>
      </div>
    </div>
  <div v-if="review.assets && review.assets.length>0">
    <GalleryRow :assets="review.assets"></GalleryRow>
  </div>
  
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import GalleryRow from '../gallery/GalleryRow'
import AuthorAvatar from "../shared/AuthorAvatar";

export default {
  name: "ReviewItemRestaurant",
  components:{
    GalleryRow,
    AuthorAvatar
  },

  props: {
    review: {
      type: Object,
      require: true,
    },
  },


  created(){
     this.author = this.review.reservation.author || {};
  },

  methods: {
    ...mapActions("reviews", ["fetchRemoveReview", "createReview"]),

    removeReview() {
      const recipeId =
        typeof this.review.recipe === "string"
          ? this.review.recipe
          : this.review.recipe.id;
      this.fetchRemoveReview({ recipeId: recipeId, reviewId: this.review.id })
        .then((res) => {
          console.log(res);
        })
        .catch((error) => console.log(error));
    },

    editReview() {
      this.createReview({
        rating: this.review.rating,
        comment: this.review.comment,
        recipe:
          typeof this.review.recipe === "string"
            ? this.review.recipe
            : this.review.recipe.id,
        id: this.review.id,
      });
    },
  },

  computed: {
    ...mapGetters({
      deleting: "reviews/getDeleting",
    }),
    
    ...mapGetters({
      authUser: "users/getAccount",
    }),

    isAuthor(){
      return this.review && this.review.reservation && this.review.reservation.author &&
      this.review.reservation.author.id === this.authUser.id
    },

     authorPhoto() {
      return this.review && this.review.reservation && this.review.reservation.author && this.review.author.avatar
        ? this.review.reservation.author.avatar.formats.thumbnail.url
        : null;
    },
  },
};
</script>

<style scoped lang="scss">
.user-info-review,
.user-info-wrapper {
  width: 100%;
}
</style>